import { message, Modal } from 'ant-design-vue'
import type { Ref } from 'vue'
import { batchUpdateAccountBill, type AccountBillItem } from '@/api/billApi'
import { OK } from '@/common'
import { createEmptyBillRecord } from './useOtherReason'
import type { EditingField } from './useEditField'

type EmitType = {
  (event: 'update-list'): void
}

export const useBatchOperation = ({
  emit,
  selectedRowKeys,
  isBatchOperation,
  currentRecord,
  otherReasonModalVisible,
  editingField,
  editingValue,
  editFieldTitle,
  editFieldModalVisible,
}: {
  emit: EmitType
  selectedRowKeys: Ref<string[]>
  isBatchOperation: Ref<boolean>
  currentRecord: Ref<AccountBillItem>
  otherReasonModalVisible: Ref<boolean>
  editingField: Ref<EditingField>
  editingValue: Ref<any>
  editFieldTitle: Ref<string>
  editFieldModalVisible: Ref<boolean>
}) => {
  const checkSelection = () => {
    if (selectedRowKeys.value.length === 0) {
      message.warning('请至少选择一条记录')
      return false
    }
    return true
  }

  const handleBatchModify = () => {
    if (!checkSelection()) return
    isBatchOperation.value = true
    editingField.value = 'balance'
    editingValue.value = null
    editFieldTitle.value = '修改账号余额'
    editFieldModalVisible.value = true
  }

  const handleBatchUpdateStatus = () => {
    if (!checkSelection()) return
    isBatchOperation.value = true
    editingField.value = 'receivedStatus'
    editingValue.value = null
    editFieldTitle.value = '修改收款状态'
    editFieldModalVisible.value = true
  }

  const handleBatchUpdateExpected = () => {
    if (!checkSelection()) return
    currentRecord.value = { ...createEmptyBillRecord(), id: 'batch', accountName: '批量修改' }
    isBatchOperation.value = true
    otherReasonModalVisible.value = true
  }

  const handleBatchUpdateReceived = () => {
    if (!checkSelection()) return
    Modal.confirm({
      title: '更新收款信息',
      content: `确定要更新${selectedRowKeys.value.length}条记录的收款信息吗？`,
      okText: '确定',
      cancelText: '取消',
      centered: true,
      onOk: async () => {
        try {
          const res = await batchUpdateAccountBill({
            ids: selectedRowKeys.value,
            updateAccountInfo: true,
          })
          if (res && res.code === OK) {
            message.success(`成功更新${selectedRowKeys.value.length}条记录的收款信息`)
            emit('update-list')
          }
        } catch (error) {
          console.log('[ error ] >', error)
        }
      },
    })
  }

  const handleBatchModifyActualReceiptTime = () => {
    if (!checkSelection()) return
    isBatchOperation.value = true
    editingField.value = 'actualReceiptTime'
    editingValue.value = null
    editFieldTitle.value = '修改实际收款时间'
    editFieldModalVisible.value = true
  }

  return {
    handleBatchModify,
    handleBatchUpdateStatus,
    handleBatchUpdateExpected,
    handleBatchUpdateReceived,
    handleBatchModifyActualReceiptTime,
  }
}
